import React from 'react';
import { NavItemDef } from '../navItems';
import { getLmsUrl } from 'data_sources/constants';

export const REPORTING_NAV_ITEMS: NavItemDef[] = [
  {
    key: 'reporting.insightsCenter',
    label: 'reporting.navItems.insightsCenter',
    path: 'insights-center',
    visibility: ({ hasPermission, isFeatureEnabled, currentOrganizationId }) => {
      const hasTrainingAccess = hasPermission('accessTrainingInsightsCenter', currentOrganizationId);
      const hasPolicyAccess = hasPermission('accessPolicyInsightsCenter', currentOrganizationId);
      const policyFlagEnabled = isFeatureEnabled('policy_insights_center');

      return hasTrainingAccess || (hasPolicyAccess && policyFlagEnabled);
    },
  },
  {
    key: 'reporting.users',
    label: 'reporting.navItems.users',
    path: 'users',
    permissions: ['reportUserList'],
  },
  {
    key: 'reporting.policyAcknowledgements',
    label: 'reporting.navItems.policyAcknowledgements',
    path: 'policy-acknowledgments',
    permissions: ['listPolicyAcknowledgementReports'],
  },
  {
    key: 'reporting.dtbs',
    label: 'reporting.navItems.dtbs',
    path: 'dtbs',
    permissions: ['getDtbReport'],
  },
  {
    key: 'reporting.trainingReports',
    label: 'reporting.navItems.trainingReports',
    href: getLmsUrl('/analytics/reports/'),
    permissions: ['trainingAdminActions'],
    featurePermission: 'training',
  },
];
